import React from "react";
import { Container } from "react-bootstrap";
import { FooterLogoSvgIcn } from "svgIcon/index";
import classNames from "classnames";
import { useStyles } from "./styles";
const FooterComponent = (props) => {
  const classes = useStyles(props);
  return (
    <div
      className={classNames(
        classes.footer,
        "footerCommon position-relative z-1 d-flex justify-content-center align-items-center"
      )}
    >
      <Container fluid="xxl">
        <div className="d-flex justify-content-center align-items-center">
          <span className="pe-2 me-1 text-end">
            Directory
            <br />
            Provided by
          </span>
          <FooterLogoSvgIcn title="Make Time Count Today" />
        </div>
      </Container>
    </div>
  );
};

export default FooterComponent;
